<template>
  <div class="sidebar" id="sidebar">
    <div class="sidebar-inner slimscroll" style="width: 100%">
      <perfect-scrollbar
        class="scroll-area"
        :settings="settings"
        @ps-scroll-y="scrollHanle"
      >
        <div id="sidebar-menu" class="sidebar-menu" style="width: 100%">
          <user-menu></user-menu>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },
  methods: {
    scrollHanle() {},
  },
};
</script>

<style scoped>
.sidebar-inner {
  height: 100vh;
}

.scroll-area {
  height: 100%;
  max-height: 100%;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}

#sidebar-menu {
  max-height: 100%;
  overflow-y: auto;
  padding-bottom: 80px;
}
</style>
